import React, { FC, ReactNode, useContext, useReducer } from "react";
import { ResultRegion } from "@app/projects/results/common";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";

import SpecialtyGroupExceptionPanel, {
  getInitialFormState,
  mergeFormAndException
} from "@app/projects/network-assessment/SpecialtyGroupExceptionPanel";
import { editExceptionFormReducer, hasChanges, hasValidFields } from "@app/exceptions/editExceptionReducer";
import { SpecialtyGroupException } from "@app/exceptions/interfaces";
import { SpecialtyGroupExceptionStatus } from "@app/exceptions/enums";
import { QESButton } from "@app/shared/qes-standards/Button";

interface ExceptionFlyoutProps {
  customProjectId: number;
  exception: SpecialtyGroupException;
  specialtyGroupName: string;
  specialtyGroupCode: string;
  region: ResultRegion;
  handleSubmit: (exceptionToSubmit: SpecialtyGroupException) => void;
  children?: ReactNode;
}

const ExceptionFlyout: FC<React.PropsWithChildren<ExceptionFlyoutProps>> = (props: ExceptionFlyoutProps) => {
  const flyoutContext = useContext(FlyoutContext);
  const [exceptionFormState, formDispatch] = useReducer(editExceptionFormReducer, getInitialFormState(props.exception));

  const handleSubmit = () => {
    const result = mergeFormAndException(props.exception, exceptionFormState, props.region, props.specialtyGroupCode);
    props.handleSubmit(result);
    flyoutContext.handleCloseFlyout();
  }

  return (
    <>
      <SpecialtyGroupExceptionPanel
        customProjectId={props.customProjectId}
        exception={props.exception}
        expandedColumnSizes={true}
        specialtyGroupName={props.specialtyGroupName}
        specialtyGroupCode={props.specialtyGroupCode}
        region={props.region}
        formState={exceptionFormState}
        formDispatch={formDispatch}
      />
      <FlyoutFooter
        submitButton={<QESButton qesType="primary" qesTestId="exception-flyout__submit"
                                 disabled={!!props.exception && props.exception.specialtyGroupExceptionStatus !== SpecialtyGroupExceptionStatus.Archived
                                   && !hasChanges(exceptionFormState) || !hasValidFields(exceptionFormState)}
                                 onClick={handleSubmit}>Submit</QESButton>}
      />
    </>
  );
}

export default ExceptionFlyout;